<router-outlet></router-outlet>
<app-cookie-consent></app-cookie-consent>
<app-tool-overlay></app-tool-overlay>
<!-- NG21-MIGRATION(stufe-0/5): showTransformOptions doppelt gebunden; *TransitionOptions sind in PrimeNG 21 wirkungslos -> motionOptions; mt-7-Hack (§11.2) -->
<p-toast [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'300ms'" [hideTransitionOptions]="'300ms'"
  [showTransformOptions]="'translateX(100%)'" styleClass="mt-7"></p-toast>
<p-confirmDialog [closable]="false" [draggable]="false"></p-confirmDialog>
<!-- "Trotzdem veröffentlichen?" with a third way out to the view's details
     (ConfirmationDialogService#confirmPublishWithIssuesOrDetails): close() reports
     CANCEL = "Details ansehen", reject() reports REJECT = "Abbrechen" -->
<p-confirmDialog
  key="publishIssues"
  #publishIssuesDialog
  [closable]="false"
  [draggable]="false"
  [closeOnEscape]="false">
  <ng-template pTemplate="footer">
    <p-button
      label="Abbrechen"
      icon="fas fa-xmark"
      [text]="true"
      severity="secondary"
      (onClick)="publishIssuesDialog.reject()" />
    <p-button
      label="Details ansehen"
      icon="fas fa-list-check"
      [outlined]="true"
      (onClick)="publishIssuesDialog.close($event)" />
    <p-button
      label="Trotzdem veröffentlichen"
      icon="fas fa-check"
      (onClick)="publishIssuesDialog.accept()" />
  </ng-template>
</p-confirmDialog>
<!-- Unpublished topics of a view about to be published
     (ConfirmationDialogService#confirmPublishTopics): close() reports
     CANCEL = "Nur Ansicht veröffentlichen", reject() reports REJECT = "Abbrechen" -->
<p-confirmDialog
  key="publishTopics"
  #publishTopicsDialog
  [closable]="false"
  [draggable]="false"
  [closeOnEscape]="false">
  <ng-template pTemplate="footer">
    <p-button
      label="Abbrechen"
      icon="fas fa-xmark"
      [text]="true"
      severity="secondary"
      (onClick)="publishTopicsDialog.reject()" />
    <p-button
      label="Nur Ansicht veröffentlichen"
      icon="fas fa-eye-slash"
      [outlined]="true"
      (onClick)="publishTopicsDialog.close($event)" />
    <p-button
      label="Mit Thema veröffentlichen"
      icon="fas fa-check"
      (onClick)="publishTopicsDialog.accept()" />
  </ng-template>
</p-confirmDialog>
